import { RouteConfig } from "vue-router";

const clientes: RouteConfig = {
  path: "/clientes",
  name: "clientes",
  component: () => import(/* webpackChunkName: "clientes" */ "@/views/Clientes.vue"),
};

export default clientes;
